import {
  FileRepository
} from "./chunk-KQSKBC7C.js";
import "./chunk-CCHBLTQG.js";
import "./chunk-J3DZJUY2.js";
import {
  Plugin
} from "./chunk-XX3CIG5U.js";
import "./chunk-624QZG55.js";

// node_modules/@ckeditor/ckeditor5-adapter-ckfinder/src/utils.js
var TOKEN_COOKIE_NAME = "ckCsrfToken";
var TOKEN_LENGTH = 40;
var tokenCharset = "abcdefghijklmnopqrstuvwxyz0123456789";
function getCsrfToken() {
  let token = getCookie(TOKEN_COOKIE_NAME);
  if (!token || token.length != TOKEN_LENGTH) {
    token = generateToken(TOKEN_LENGTH);
    setCookie(TOKEN_COOKIE_NAME, token);
  }
  return token;
}
function getCookie(name) {
  name = name.toLowerCase();
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const pair = part.split("=");
    const key = decodeURIComponent(pair[0].trim().toLowerCase());
    if (key === name) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}
function setCookie(name, value) {
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + ";path=/";
}
function generateToken(length) {
  let result = "";
  const randValues = new Uint8Array(length);
  window.crypto.getRandomValues(randValues);
  for (let j = 0; j < randValues.length; j++) {
    const character = tokenCharset.charAt(randValues[j] % tokenCharset.length);
    result += Math.random() > 0.5 ? character.toUpperCase() : character;
  }
  return result;
}

// node_modules/@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter.js
var CKFinderUploadAdapter = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get requires() {
    return [FileRepository];
  }
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "CKFinderUploadAdapter";
  }
  /**
   * @inheritDoc
   */
  init() {
    const url = this.editor.config.get("ckfinder.uploadUrl");
    if (!url) {
      return;
    }
    this.editor.plugins.get(FileRepository).createUploadAdapter = (loader) => new UploadAdapter(loader, url, this.editor.t);
  }
};
var UploadAdapter = class {
  /**
   * Creates a new adapter instance.
   */
  constructor(loader, url, t) {
    this.loader = loader;
    this.url = url;
    this.t = t;
  }
  /**
   * Starts the upload process.
   *
   * @see module:upload/filerepository~UploadAdapter#upload
   */
  upload() {
    return this.loader.file.then((file) => {
      return new Promise((resolve, reject) => {
        this._initRequest();
        this._initListeners(resolve, reject, file);
        this._sendRequest(file);
      });
    });
  }
  /**
   * Aborts the upload process.
   *
   * @see module:upload/filerepository~UploadAdapter#abort
   */
  abort() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }
  /**
   * Initializes the XMLHttpRequest object.
   */
  _initRequest() {
    const xhr = this.xhr = new XMLHttpRequest();
    xhr.open("POST", this.url, true);
    xhr.responseType = "json";
  }
  /**
   * Initializes XMLHttpRequest listeners.
   *
   * @param resolve Callback function to be called when the request is successful.
   * @param reject Callback function to be called when the request cannot be completed.
   * @param file File instance to be uploaded.
   */
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    const t = this.t;
    const genericError = t("Cannot upload file:") + ` ${file.name}.`;
    xhr.addEventListener("error", () => reject(genericError));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;
      if (!response || !response.uploaded) {
        return reject(response && response.error && response.error.message ? response.error.message : genericError);
      }
      resolve({
        default: response.url
      });
    });
    if (xhr.upload) {
      xhr.upload.addEventListener("progress", (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }
  /**
   * Prepares the data and sends the request.
   *
   * @param file File instance to be uploaded.
   */
  _sendRequest(file) {
    const data = new FormData();
    data.append("upload", file);
    data.append("ckCsrfToken", getCsrfToken());
    this.xhr.send(data);
  }
};
export {
  CKFinderUploadAdapter as default
};
/*! Bundled license information:

@ckeditor/ckeditor5-adapter-ckfinder/src/utils.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)
  (* istanbul ignore else -- @preserve *)
*/
//# sourceMappingURL=@ckeditor_ckeditor5-adapter-ckfinder_src_uploadadapter.js.map
